module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"fileSelected":"file selezionato","filesSelected":"file selezionati","unselectFiles":"Deseleziona i file","selectAll":"Seleziona tutti i file","enableFolderView":"Abilita vista cartelle","enableFlatFilesView":"Visualizza tutte le foto"}}')
  delete Component.options._Ctor
}
